import React, { useState }  from "react";
import InputField from "components/fields/InputField";
import Button from "components/button";
import { connect } from "react-redux";
import { loginRequest } from "../../redux/auth/authState";
import { Alert, Card, Form } from 'antd';
import { BadgeCheck, UserPlus } from "lucide-react";

const VerifyAccount = ({ login, loading, error }) => {

  const [form] = Form.useForm();
  
  const handleSubmit = (e) => {
    
  };

  return (
      <div className="relative max-w-[440px] items-center justify-center  md:mx-0 md:px-0 mt-[3rem]" >
      <Card 
        className="w-[440px] dark:border-gray-600 bg-card text-card-foreground flex flex-col gap-6 rounded-xl shadow-2xl border-2 border-purple-100">

          <div className="flex flex-col items-center justify-center mb-6 space-y-2">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-2">
              <BadgeCheck className="w-8 h-8 text-white"/>
            </div>
            <h1 className="text-xl font-medium">
              Verify Your Account
            </h1>
          </div>
          {error &&
          <div className="min-h-[18px] my-3">
              <Alert className="p-3 text-red-700" message={error} type="error" showIcon /> 
          </div>  
          }

          <div className="text-center mt-8 mb-4">
            <p className="text-gray-800">
              Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? 
              If you didn't receive the email, we will gladly send you another.
            </p>
          </div>

          <form className="form" 
            form={form} >
            <div className="h-full w-full max-w-full flex-col items-center lg:pl-0 ">

                <Button type="submit" 
                  extra={`btn-gradient-emerald h-9
                  w-full ${loading && 'disabled'}`} 
                  disabled={loading}
                >
                  Resend Verification Email
                </Button>
            </div>
          </form>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);
